<!-- Header -->
<ion-header
  class="ion-no-border"
  [class.ion-header-modal-desktop]="platformType === platformEnum.desktop"
  [class.ion-header-modal-tablet]="platformType === platformEnum.tablet"
  [class.ion-header-modal-mobile]="platformType === platformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons *ngIf="platformType === platformEnum.desktop" slot="end">
      <ion-button
        data-cy="inventory-item-modal-close-button"
        (click)="dismissModal()"
      >
        <ion-icon
          data-cy="inventory-item-modal-close-button-icon"
          slot="icon-only"
          name="close-outline"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="inventory-item-modal-title">
      {{
        'i18n.inventory.inventoryWorksheet.inventoryInformationModal.title'
          | translate
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="inventory-item-modal_content"
  [class.ion-content-modal-desktop]="platformType === platformEnum.desktop"
  [class.ion-content-modal-tablet]="platformType === platformEnum.tablet"
  [class.ion-content-modal-mobile]="platformType === platformEnum.mobile"
>
  <ion-grid>
    <ion-row *ngIf="inventoryItem?.productCatchWeightFlag" class="catch">
      <ion-col size="2">
        <ion-icon name="information-circle"></ion-icon>
      </ion-col>
      <ion-col size="10">
        <p class="information">
          {{
            'i18n.inventory.inventoryWorksheet.inventoryInformationModal.catchWeight'
              | translate
          }}
        </p>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="inventoryItem?.overrideFlag" class="price-override">
      <ion-col size="2">
        <ion-icon name="information-circle"></ion-icon>
      </ion-col>
      <ion-col size="10">
        <p class="information">
          {{
            'i18n.inventory.inventoryWorksheet.inventoryInformationModal.priceOverride'
              | translate
          }}
        </p>
      </ion-col>
    </ion-row>

    <ion-row
      *ngIf="
        inventoryItem?.productBadPricingCaseFlag ||
        inventoryItem?.productBadPricingUnitFlag
      "
      class="price"
    >
      <ion-col size="2">
        <ion-icon name="information-circle"></ion-icon>
      </ion-col>
      <ion-col
        size="10"
        *ngIf="
          inventoryItem?.productBadPricingCaseFlag ||
          (inventoryItem?.productCatchWeightFlag &&
            inventoryItem?.productBadPricingUnitFlag)
        "
      >
        <p class="information">
          {{
            'i18n.inventory.inventoryWorksheet.inventoryInformationModal.priceCase'
              | translate
          }}
        </p>
      </ion-col>
      <ion-col
        size="10"
        *ngIf="
          inventoryItem?.productBadPricingUnitFlag &&
          !inventoryItem?.productBadPricingCaseFlag &&
          !inventoryItem?.productCatchWeightFlag
        "
      >
        <p class="information">
          {{
            'i18n.inventory.inventoryWorksheet.inventoryInformationModal.priceUnit'
              | translate
          }}
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="ion-footer-modal ion-footer-modal-desktop">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="inventory-information-modal-desktop-tablet-close-button"
        [ngClass]="
          platformType === platformEnum.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal()"
      >
        {{ 'i18n.common.close' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
